<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import ActivityLogInfo from "./components/ActivityLogInfo.svelte";
    import ActivityLogRequest from "./components/ActivityLogRequest.svelte";
    import ActivityLogResponse from "./components/ActivityLogResponse.svelte";

    import { user } from "../../stores";

    import {
        PageLoading,
        PageHead,
    } from "../../Components/Common/index.svelte";
    import { showError } from "../../Utils/utilFunctions.svelte";
    import ActivityLogChanges from "./components/ActivityLogChanges.svelte";

    export let params = {};

    $: isUserEnableSeeRequest = $user.role >= 20;

    let isLoadingActivityLog = false,
        activityLogData = {};

    onMount(() => {
        if (params.id) loadActivityLogById(params.id);
    });

    const loadActivityLogById = async (id) => {
        isLoadingActivityLog = true;

        await apiMethods.getMethod.getActivityLogById(id).then(async (res) => {
            if (res.id) {
                activityLogData = { ...res };
            } else showError(res.error);
        });

        isLoadingActivityLog = false;
    };
</script>

{#if isLoadingActivityLog}
    <PageLoading />
{:else}
    <PageHead title="View Activity log" />

    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <ActivityLogInfo {activityLogData} />

            <ActivityLogChanges data={activityLogData} />

            {#if isUserEnableSeeRequest}
                <ActivityLogRequest request={activityLogData.request} />
            {/if}

            <ActivityLogResponse response={activityLogData.response} />
        </div>
    </div>
{/if}
